// extracted by mini-css-extract-plugin
module.exports = {"root":"About_root__25_UD","role":"About_role__1Jawx","author":"About_author__2t7RA"};